module.exports = __webpack_public_path__ + "static/media/Impreza-GG-Wagon-WRX.ddfff5df.webp";